import * as R from "ramda";
import {
  GOOGLE_GEOCODING_CLIENT as client,
  GOOGLE_MAPS_API_KEY,
} from "./common";

export async function guessLocality({ latitude, longitude }) {
  try {
    const response = await client.get("/maps/api/geocode/json", {
      params: {
        latlng: `${latitude},${longitude}`,
        result_type: "locality|administrative_area_level_1",
        key: GOOGLE_MAPS_API_KEY,
      },
    });

    if (
      response.status === 200 &&
      response.data &&
      "status" in response.data &&
      response.data.status === "OK" &&
      "results" in response.data
    ) {
      const results = response.data.results;
      if (!Array.isArray(results)) {
        console.error("results is not an array");
        return;
      }

      const locality = results[0];
      if (!locality) {
        console.error("no results");
        return;
      }

      const matchKeywords = locality.formatted_address.split(", ");
      const matches = VALID_LOCALITIES.map(({ locality, keywords }) => ({
        locality,
        matches: R.intersection(keywords, matchKeywords),
      }));

      const match = R.reduce(
        R.maxBy((match) => {
          return match.matches ? match.matches.length : 0;
        }),
        0,
        matches
      );
      if (match) {
        return match.locality;
      }
    }
  } catch (error) {
    console.error(`We failed to guess the city, ${error}`, error);
  }
}

export const VALID_LOCALITIES = [
  {
    keywords: ["Chihuahua", "Chihuahua"],
    locality: "Chihuahua, Chihuahua",
  },
  {
    keywords: ["Ciudad Juárez", "Chihuahua"],
    locality: "Ciudad Juárez, Chihuahua",
  },
  {
    keywords: ["Hermosillo", "Sonora"],
    locality: "Hermosillo, Sonora",
  },
  {
    keywords: ["Mexicali", "Baja California"],
    locality: "Mexicali, Baja California",
  },
];
